// Redux Reducer

import {  LOGIN_SUCCESS, 
          LOGIN_FAIL,  
          GET_USER_SUCCESS, 
          GET_USER_FAIL, 
          CREATE_PROPERTY_SUCCESS, 
          CREATE_PROPERTY_FAIL, 
          GET_ALL_USERS_SUCCESS, 
          GET_ALL_USERS_FAIL,
          UPDATE_MAP_LOCATION,
          UPLOAD_IMAGE_SUCCESS,
          UPLOAD_IMAGE_FAIL,
          GET_PROPERTIES_BY_SELLER_ID_SUCCESS,
          GET_PROPERTIES_BY_SELLER_ID_FAIL,
          EDIT_PROPERTY_REQUEST,
          EDIT_PROPERTY_SUCCESS,
          EDIT_PROPERTY_FAIL,
          GET_PROPERTY_BY_ID,
          GET_PROPERTIES_PENDING_SUCCESS, 
          GET_PROPERTIES_PENDING_FAIL,
          GET_PROPERTIES_LIST_SUCCESS,
          GET_PROPERTIES_LIST_FAIL, 
          CREATE_USER_REQUEST,
          CREATE_USER_SUCCESS,
          CREATE_USER_FAIL,
          GET_ALL_SELLERS_SUCCESS,
          GET_ALL_SELLERS_FAIL,
          UPDATE_SELLER_REQUEST,
          UPDATE_SELLER_SUCCESS,
          UPDATE_SELLER_FAIL,
          GET_SELLER_BY_ID_REQUEST,
          GET_SELLER_BY_ID_SUCCESS,
          GET_SELLER_BY_ID_FAILURE,
          CREATE_VISITA_REQUEST,
          CREATE_VISITA_SUCCESS,
          CREATE_VISITA_FAIL,
          GET_ALL_VISITAS_REQUEST,
          GET_ALL_VISITAS_SUCCESS,
          GET_ALL_VISITAS_FAIL,
          GET_VISITAS_BY_PROPERTY_REQUEST,
          GET_VISITAS_BY_PROPERTY_SUCCESS,
          GET_VISITAS_BY_PROPERTY_FAIL,
          GET_PROPERTIES_BY_SELLER,
          GET_PROPERTIES_BY_SELLER_ERROR,
          GET_PROPERTIES_CLOSED_BY_SELLER_ID_SUCCESS,
          GET_PROPERTIES_CLOSED_BY_SELLER_ID_FAIL,
          FETCH_RENTALS_REQUEST,
          FETCH_RENTALS_SUCCESS,
          FETCH_RENTALS_FAILURE,
          FETCH_RENTAL_REQUEST,
          FETCH_RENTAL_SUCCESS,
          FETCH_RENTAL_FAILURE,
          CREATE_RENTAL_REQUEST,
          CREATE_RENTAL_SUCCESS,
          CREATE_RENTAL_FAILURE,
          UPDATE_RENTAL_REQUEST,
          UPDATE_RENTAL_SUCCESS,
          UPDATE_RENTAL_FAILURE,
          DELETE_RENTAL_REQUEST,
          DELETE_RENTAL_SUCCESS,
          DELETE_RENTAL_FAILURE,
          CANCEL_RENTAL_REQUEST,
          CANCEL_RENTAL_SUCCESS,
          CANCEL_RENTAL_FAILURE,
          REACTIVATE_RENTAL_REQUEST,
          REACTIVATE_RENTAL_SUCCESS,
          REACTIVATE_RENTAL_FAILURE,
          GET_CLOSED_PROPERTIES_SUCCESS,
          GET_CLOSED_PROPERTIES_FAIL,   
          SESSION_STARTED,
          SESSION_ENDED,
          SESSION_HISTORY_SUCCESS,
          SESSION_HISTORY_FAIL,
          SESSION_MONTHLY_SUCCESS,
          SESSION_MONTHLY_FAIL,
          FETCH_EVENTS_REQUEST, FETCH_EVENTS_SUCCESS, FETCH_EVENTS_FAIL,
          CREATE_EVENT_REQUEST, CREATE_EVENT_SUCCESS, CREATE_EVENT_FAIL,
          UPDATE_EVENT_REQUEST, UPDATE_EVENT_SUCCESS, UPDATE_EVENT_FAIL,
          DELETE_EVENT_REQUEST, DELETE_EVENT_SUCCESS, DELETE_EVENT_FAIL,
          FETCH_UPCOMING_EVENTS_REQUEST, FETCH_UPCOMING_EVENTS_SUCCESS, FETCH_UPCOMING_EVENTS_FAIL,
          FETCH_EVENT_BY_ID_REQUEST, FETCH_EVENT_BY_ID_SUCCESS, FETCH_EVENT_BY_ID_FAIL,
          MARK_EVENT_SEEN_REQUEST, MARK_EVENT_SEEN_SUCCESS, MARK_EVENT_SEEN_FAIL,
          CHANGE_EVENT_STATUS_REQUEST, CHANGE_EVENT_STATUS_SUCCESS, CHANGE_EVENT_STATUS_FAIL,
          CREATE_CLIENT_REQUEST, CREATE_CLIENT_SUCCESS, CREATE_CLIENT_FAIL,
          GET_CLIENTS_BY_SELLER_REQUEST, GET_CLIENTS_BY_SELLER_SUCCESS, GET_CLIENTS_BY_SELLER_FAIL,
          GET_ALL_CLIENTS_REQUEST, GET_ALL_CLIENTS_SUCCESS, GET_ALL_CLIENTS_FAIL,
          GET_CLIENT_BY_ID_REQUEST, GET_CLIENT_BY_ID_SUCCESS, GET_CLIENT_BY_ID_FAIL,
          UPDATE_CLIENT_REQUEST, UPDATE_CLIENT_SUCCESS, UPDATE_CLIENT_FAIL,
          DELETE_CLIENT_REQUEST, DELETE_CLIENT_SUCCESS, DELETE_CLIENT_FAIL,
          ASSOCIATE_CLIENT_PROPERTY_REQUEST, ASSOCIATE_CLIENT_PROPERTY_SUCCESS, ASSOCIATE_CLIENT_PROPERTY_FAIL,
          GET_CLIENTS_BY_PROPERTY_REQUEST, GET_CLIENTS_BY_PROPERTY_SUCCESS, GET_CLIENTS_BY_PROPERTY_FAIL,
          // Rental Management action types
          FETCH_RENTAL_DASHBOARD_REQUEST, FETCH_RENTAL_DASHBOARD_SUCCESS, FETCH_RENTAL_DASHBOARD_FAIL,
          FETCH_ACTIVE_RENTALS_REQUEST, FETCH_ACTIVE_RENTALS_SUCCESS, FETCH_ACTIVE_RENTALS_FAIL,
          FETCH_RENTAL_DETAIL_REQUEST, FETCH_RENTAL_DETAIL_SUCCESS, FETCH_RENTAL_DETAIL_FAIL,
          FETCH_OVERDUE_PAYMENTS_REQUEST, FETCH_OVERDUE_PAYMENTS_SUCCESS, FETCH_OVERDUE_PAYMENTS_FAIL,
          FETCH_EXPIRING_CONTRACTS_REQUEST, FETCH_EXPIRING_CONTRACTS_SUCCESS, FETCH_EXPIRING_CONTRACTS_FAIL,
          GENERATE_PAYMENT_SCHEDULE_REQUEST, GENERATE_PAYMENT_SCHEDULE_SUCCESS, GENERATE_PAYMENT_SCHEDULE_FAIL,
          FETCH_RENTAL_PAYMENTS_REQUEST, FETCH_RENTAL_PAYMENTS_SUCCESS, FETCH_RENTAL_PAYMENTS_FAIL,
          REGISTER_PAYMENT_REQUEST, REGISTER_PAYMENT_SUCCESS, REGISTER_PAYMENT_FAIL,
          UPDATE_OVERDUE_PAYMENTS_REQUEST, UPDATE_OVERDUE_PAYMENTS_SUCCESS, UPDATE_OVERDUE_PAYMENTS_FAIL,
          CREATE_RENTAL_ADJUSTMENT_REQUEST, CREATE_RENTAL_ADJUSTMENT_SUCCESS, CREATE_RENTAL_ADJUSTMENT_FAIL,
          SIMULATE_RENTAL_ADJUSTMENT_REQUEST, SIMULATE_RENTAL_ADJUSTMENT_SUCCESS, SIMULATE_RENTAL_ADJUSTMENT_FAIL,
          FETCH_ADJUSTMENT_HISTORY_REQUEST, FETCH_ADJUSTMENT_HISTORY_SUCCESS, FETCH_ADJUSTMENT_HISTORY_FAIL,
          FETCH_UPCOMING_ADJUSTMENTS_REQUEST, FETCH_UPCOMING_ADJUSTMENTS_SUCCESS, FETCH_UPCOMING_ADJUSTMENTS_FAIL,
          NOTIFY_ADJUSTMENT_REQUEST, NOTIFY_ADJUSTMENT_SUCCESS, NOTIFY_ADJUSTMENT_FAIL,
          CREATE_RENTAL_TENANT_REQUEST, CREATE_RENTAL_TENANT_SUCCESS, CREATE_RENTAL_TENANT_FAIL,
          FETCH_RENTAL_TENANTS_REQUEST, FETCH_RENTAL_TENANTS_SUCCESS, FETCH_RENTAL_TENANTS_FAIL,
          UPDATE_RENTAL_TENANT_REQUEST, UPDATE_RENTAL_TENANT_SUCCESS, UPDATE_RENTAL_TENANT_FAIL,
          DELETE_RENTAL_TENANT_REQUEST, DELETE_RENTAL_TENANT_SUCCESS, DELETE_RENTAL_TENANT_FAIL,
          CLEAR_RENTAL_STATE, SET_RENTAL_LOADING,
          // Estadísticas action types
          FETCH_VISITAS_STATS_REQUEST, FETCH_VISITAS_STATS_SUCCESS, FETCH_VISITAS_STATS_FAIL,
          FETCH_VISITAS_STATS_PERIOD_REQUEST, FETCH_VISITAS_STATS_PERIOD_SUCCESS, FETCH_VISITAS_STATS_PERIOD_FAIL,
          FETCH_SELLERS_STATS_REQUEST, FETCH_SELLERS_STATS_SUCCESS, FETCH_SELLERS_STATS_FAIL,
          FETCH_REUNIONES_RANKING_REQUEST, FETCH_REUNIONES_RANKING_SUCCESS, FETCH_REUNIONES_RANKING_FAIL,
          FETCH_REUNIONES_INFORME_REQUEST, FETCH_REUNIONES_INFORME_SUCCESS, FETCH_REUNIONES_INFORME_FAIL,
          FETCH_REUNIONES_TIPS_REQUEST, FETCH_REUNIONES_TIPS_SUCCESS, FETCH_REUNIONES_TIPS_FAIL,
          CREATE_REUNION_REQUEST, CREATE_REUNION_SUCCESS, CREATE_REUNION_FAIL,
          UPDATE_REUNION_REQUEST, UPDATE_REUNION_SUCCESS, UPDATE_REUNION_FAIL,
          DELETE_REUNION_REQUEST, DELETE_REUNION_SUCCESS, DELETE_REUNION_FAIL,
          FETCH_REUNIONES_LIST_REQUEST, FETCH_REUNIONES_LIST_SUCCESS, FETCH_REUNIONES_LIST_FAIL,
          FETCH_ACTIVE_SELLERS_REQUEST, FETCH_ACTIVE_SELLERS_SUCCESS, FETCH_ACTIVE_SELLERS_FAIL,
          FETCH_REUNIONES_DASHBOARD_REQUEST, FETCH_REUNIONES_DASHBOARD_SUCCESS, FETCH_REUNIONES_DASHBOARD_FAIL,
          FETCH_REUNIONES_COMPARATIVA_REQUEST, FETCH_REUNIONES_COMPARATIVA_SUCCESS, FETCH_REUNIONES_COMPARATIVA_FAIL,
          FETCH_REUNIONES_ANUAL_REQUEST, FETCH_REUNIONES_ANUAL_SUCCESS, FETCH_REUNIONES_ANUAL_FAIL,
          FETCH_VISITAS_AGENT_STATS_REQUEST, FETCH_VISITAS_AGENT_STATS_SUCCESS, FETCH_VISITAS_AGENT_STATS_FAIL,
          CLEAR_ESTADISTICAS_STATE,
          // Visitas Externas
          CREATE_VISITA_EXTERNA_REQUEST, CREATE_VISITA_EXTERNA_SUCCESS, CREATE_VISITA_EXTERNA_FAIL,
          GET_VISITAS_EXTERNAS_REQUEST, GET_VISITAS_EXTERNAS_SUCCESS, GET_VISITAS_EXTERNAS_FAIL,
          GET_VISITAS_EXTERNAS_BY_AGENT_REQUEST, GET_VISITAS_EXTERNAS_BY_AGENT_SUCCESS, GET_VISITAS_EXTERNAS_BY_AGENT_FAIL,
          UPDATE_VISITA_EXTERNA_REQUEST, UPDATE_VISITA_EXTERNA_SUCCESS, UPDATE_VISITA_EXTERNA_FAIL,
          DELETE_VISITA_EXTERNA_REQUEST, DELETE_VISITA_EXTERNA_SUCCESS, DELETE_VISITA_EXTERNA_FAIL,
          CREATE_OPERACION_EXTERNA_REQUEST, CREATE_OPERACION_EXTERNA_SUCCESS, CREATE_OPERACION_EXTERNA_FAIL,
          GET_OPERACIONES_EXTERNAS_REQUEST, GET_OPERACIONES_EXTERNAS_SUCCESS, GET_OPERACIONES_EXTERNAS_FAIL,
          GET_OPERACION_EXTERNA_BY_ID_REQUEST, GET_OPERACION_EXTERNA_BY_ID_SUCCESS, GET_OPERACION_EXTERNA_BY_ID_FAIL,
          UPDATE_OPERACION_EXTERNA_REQUEST, UPDATE_OPERACION_EXTERNA_SUCCESS, UPDATE_OPERACION_EXTERNA_FAIL,
          DELETE_OPERACION_EXTERNA_REQUEST, DELETE_OPERACION_EXTERNA_SUCCESS, DELETE_OPERACION_EXTERNA_FAIL,
          // Property Versioning & Approval
          FETCH_PROPERTY_VERSIONS_REQUEST, FETCH_PROPERTY_VERSIONS_SUCCESS, FETCH_PROPERTY_VERSIONS_FAIL,
          REVERT_PROPERTY_VERSION_REQUEST, REVERT_PROPERTY_VERSION_SUCCESS, REVERT_PROPERTY_VERSION_FAIL,
          FETCH_PROPERTY_COMMENTS_REQUEST, FETCH_PROPERTY_COMMENTS_SUCCESS, FETCH_PROPERTY_COMMENTS_FAIL,
          ADD_PROPERTY_COMMENT_REQUEST, ADD_PROPERTY_COMMENT_SUCCESS, ADD_PROPERTY_COMMENT_FAIL,
          MARK_COMMENT_READ_SUCCESS, MARK_COMMENT_READ_FAIL,
          APPROVE_PROPERTY_REQUEST, APPROVE_PROPERTY_SUCCESS, APPROVE_PROPERTY_FAIL,
          REJECT_PROPERTY_REQUEST, REJECT_PROPERTY_SUCCESS, REJECT_PROPERTY_FAIL,
          REQUEST_REVISION_REQUEST, REQUEST_REVISION_SUCCESS, REQUEST_REVISION_FAIL,
          // VRC
          CREATE_VRC_REQUEST, CREATE_VRC_SUCCESS, CREATE_VRC_FAIL,
          FETCH_VRCS_REQUEST, FETCH_VRCS_SUCCESS, FETCH_VRCS_FAIL,
          FETCH_VRC_BY_ID_REQUEST, FETCH_VRC_BY_ID_SUCCESS, FETCH_VRC_BY_ID_FAIL,
          UPDATE_VRC_REQUEST, UPDATE_VRC_SUCCESS, UPDATE_VRC_FAIL,
          DELETE_VRC_REQUEST, DELETE_VRC_SUCCESS, DELETE_VRC_FAIL,
          FETCH_VRC_VERSIONS_REQUEST, FETCH_VRC_VERSIONS_SUCCESS, FETCH_VRC_VERSIONS_FAIL,
          REVERT_VRC_VERSION_REQUEST, REVERT_VRC_VERSION_SUCCESS, REVERT_VRC_VERSION_FAIL,
          FETCH_VRC_BY_CODE_REQUEST, FETCH_VRC_BY_CODE_SUCCESS, FETCH_VRC_BY_CODE_FAIL,
          DUPLICATE_VRC_REQUEST, DUPLICATE_VRC_SUCCESS, DUPLICATE_VRC_FAIL,
          FETCH_VRC_STATS_REQUEST, FETCH_VRC_STATS_SUCCESS, FETCH_VRC_STATS_FAIL,
          CLEAR_VRC_DETAIL,
          // Admin Rentals (Solo Administración)
          FETCH_ADMIN_RENTAL_DASHBOARD_REQUEST, FETCH_ADMIN_RENTAL_DASHBOARD_SUCCESS, FETCH_ADMIN_RENTAL_DASHBOARD_FAIL,
          FETCH_ACTIVE_ADMIN_RENTALS_REQUEST, FETCH_ACTIVE_ADMIN_RENTALS_SUCCESS, FETCH_ACTIVE_ADMIN_RENTALS_FAIL,
          FETCH_ADMIN_RENTAL_LIST_REQUEST, FETCH_ADMIN_RENTAL_LIST_SUCCESS, FETCH_ADMIN_RENTAL_LIST_FAIL,
          FETCH_ADMIN_RENTAL_DETAIL_REQUEST, FETCH_ADMIN_RENTAL_DETAIL_SUCCESS, FETCH_ADMIN_RENTAL_DETAIL_FAIL,
          FETCH_EXPIRING_ADMIN_RENTALS_REQUEST, FETCH_EXPIRING_ADMIN_RENTALS_SUCCESS, FETCH_EXPIRING_ADMIN_RENTALS_FAIL,
          FETCH_OVERDUE_ADMIN_PAYMENTS_REQUEST, FETCH_OVERDUE_ADMIN_PAYMENTS_SUCCESS, FETCH_OVERDUE_ADMIN_PAYMENTS_FAIL,
          FETCH_ADMIN_CONTRACT_SUMMARY_REQUEST, FETCH_ADMIN_CONTRACT_SUMMARY_SUCCESS, FETCH_ADMIN_CONTRACT_SUMMARY_FAIL,
          CREATE_ADMIN_RENTAL_REQUEST, CREATE_ADMIN_RENTAL_SUCCESS, CREATE_ADMIN_RENTAL_FAIL,
          UPDATE_ADMIN_RENTAL_REQUEST, UPDATE_ADMIN_RENTAL_SUCCESS, UPDATE_ADMIN_RENTAL_FAIL,
          DELETE_ADMIN_RENTAL_REQUEST, DELETE_ADMIN_RENTAL_SUCCESS, DELETE_ADMIN_RENTAL_FAIL,
          CANCEL_ADMIN_RENTAL_REQUEST, CANCEL_ADMIN_RENTAL_SUCCESS, CANCEL_ADMIN_RENTAL_FAIL,
          REACTIVATE_ADMIN_RENTAL_REQUEST, REACTIVATE_ADMIN_RENTAL_SUCCESS, REACTIVATE_ADMIN_RENTAL_FAIL,
          GENERATE_ADMIN_PAYMENT_SCHEDULE_REQUEST, GENERATE_ADMIN_PAYMENT_SCHEDULE_SUCCESS, GENERATE_ADMIN_PAYMENT_SCHEDULE_FAIL,
          FETCH_ADMIN_RENTAL_PAYMENTS_REQUEST, FETCH_ADMIN_RENTAL_PAYMENTS_SUCCESS, FETCH_ADMIN_RENTAL_PAYMENTS_FAIL,
          REGISTER_ADMIN_RENTAL_PAYMENT_REQUEST, REGISTER_ADMIN_RENTAL_PAYMENT_SUCCESS, REGISTER_ADMIN_RENTAL_PAYMENT_FAIL,
          FETCH_UPCOMING_ADMIN_PAYMENTS_REQUEST, FETCH_UPCOMING_ADMIN_PAYMENTS_SUCCESS, FETCH_UPCOMING_ADMIN_PAYMENTS_FAIL,
          UPDATE_OVERDUE_ADMIN_PAYMENTS_REQUEST, UPDATE_OVERDUE_ADMIN_PAYMENTS_SUCCESS, UPDATE_OVERDUE_ADMIN_PAYMENTS_FAIL,
          CREATE_ADMIN_RENTAL_ADJUSTMENT_REQUEST, CREATE_ADMIN_RENTAL_ADJUSTMENT_SUCCESS, CREATE_ADMIN_RENTAL_ADJUSTMENT_FAIL,
          SIMULATE_ADMIN_RENTAL_ADJUSTMENT_REQUEST, SIMULATE_ADMIN_RENTAL_ADJUSTMENT_SUCCESS, SIMULATE_ADMIN_RENTAL_ADJUSTMENT_FAIL,
          FETCH_ADMIN_ADJUSTMENT_HISTORY_REQUEST, FETCH_ADMIN_ADJUSTMENT_HISTORY_SUCCESS, FETCH_ADMIN_ADJUSTMENT_HISTORY_FAIL,
          FETCH_UPCOMING_ADMIN_ADJUSTMENTS_REQUEST, FETCH_UPCOMING_ADMIN_ADJUSTMENTS_SUCCESS, FETCH_UPCOMING_ADMIN_ADJUSTMENTS_FAIL,
          NOTIFY_ADMIN_ADJUSTMENT_REQUEST, NOTIFY_ADMIN_ADJUSTMENT_SUCCESS, NOTIFY_ADMIN_ADJUSTMENT_FAIL,
          CREATE_ADMIN_RENTAL_TENANT_REQUEST, CREATE_ADMIN_RENTAL_TENANT_SUCCESS, CREATE_ADMIN_RENTAL_TENANT_FAIL,
          FETCH_ADMIN_RENTAL_TENANTS_REQUEST, FETCH_ADMIN_RENTAL_TENANTS_SUCCESS, FETCH_ADMIN_RENTAL_TENANTS_FAIL,
          UPDATE_ADMIN_RENTAL_TENANT_REQUEST, UPDATE_ADMIN_RENTAL_TENANT_SUCCESS, UPDATE_ADMIN_RENTAL_TENANT_FAIL,
          DELETE_ADMIN_RENTAL_TENANT_REQUEST, DELETE_ADMIN_RENTAL_TENANT_SUCCESS, DELETE_ADMIN_RENTAL_TENANT_FAIL,
          CLEAR_ADMIN_RENTAL_STATE
         } from './Actions/actionTypes';

const initialState = {
  properties: [],
  user: JSON.parse(localStorage.getItem('user')) || null,
  userId: localStorage.getItem('userId') || null,
  userType: localStorage.getItem('userType') || null,
  userDetails: null,
  users: [],
  propertyCreationError: null,
  mapLocation: null,
  imageUploadError: null,
  propertiesBySellerId: [],
  propertiesClosedBySellerId: [],
  property: null,
  pendingProperties: [], 
  activeProperties: [], 
  seller: null,
  sellers: [],
  sellerProperties: {},
  selleredit: null,
  loading: false,
  error: null,
  visitas: [],
  rentals: [], 
  rental: null, 
  closedProperties: [],
  sessionId: null,
  historyByUser: {}, // { [userId]: [array de sesiones] }
  monthlyStatsByUser: {}, // { [userId]: {month, totalMinutes, sessionCount} }
  events: [],
  eventsLoading: false,
  eventsError: null,
  upcomingEvents: [],
  upcomingEventsLoading: false,
  currentEvent: null,
  // Client state
  clients: [],
  clientsBySeller: [],
  clientsByProperty: [],
  currentClient: null,
  clientsLoading: false,
  clientsError: null,
  // Rental Management state
  rentalDashboard: null,
  activeRentals: [],
  rentalDetail: null,
  overduePayments: [],
  expiringContracts: [],
  rentalPayments: [],
  adjustmentHistory: [],
  upcomingAdjustments: [],
  rentalTenants: [],
  adjustmentSimulation: null,
  rentalsLoading: false,
  rentalsError: null,
  // Rental Management state
  rentalDashboard: null,
  activeRentals: [],
  rentalDetail: null,
  overduePayments: [],
  expiringContracts: [],
  rentalPayments: [],
  adjustmentHistory: [],
  upcomingAdjustments: [],
  rentalTenants: [],
  adjustmentSimulation: null,
  rentalsLoading: false,
  rentalsError: null,
  // Admin Rentals (Solo Administración) state
  adminRentalDashboard: null,
  adminRentalList: [],
  activeAdminRentals: [],
  adminRentalDetail: null,
  adminRentalPayments: { data: [], contractInfo: null, autoGenerated: false },
  overdueAdminPayments: [],
  expiringAdminRentals: [],
  upcomingAdminPayments: [],
  adminAdjustmentHistory: [],
  upcomingAdminAdjustments: [],
  adminAdjustmentSimulation: null,
  adminRentalTenants: [],
  adminContractSummary: null,
  adminRentalsLoading: false,
  adminRentalsError: null,
  // Estadísticas state
  visitasStats: null,
  visitasStatsPeriod: null,
  visitasAgentStats: null,
  sellersStats: null,
  reunionesRanking: null,
  reunionesInforme: null,
  reunionesTips: null,
  reunionesList: null,
  activeSellers: null,
  estadisticasLoading: false,
  estadisticasError: null,
  reunionCrudLoading: false,
  reunionCrudError: null,
  reunionesDashboard: null,
  reunionesComparativa: null,
  reunionesAnual: null,
  // Visitas Externas state
  visitasExternas: [],
  visitasExternasLoading: false,
  visitasExternasError: null,
  // Operaciones Externas (Punta Compradora) state
  operacionesExternas: [],
  operacionExternaDetail: null,
  operacionesExternasLoading: false,
  operacionesExternasError: null,
  // Property Versioning & Approval state
  propertyVersions: [],
  propertyComments: [],
  versioningLoading: false,
  versioningError: null,
  // VRC state
  vrcs: [],
  vrcsPagination: null,
  vrcDetail: null,
  vrcVersions: null,
  vrcStats: null,
  vrcLoading: false,
  vrcError: null,
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload,
        userId: action.payload.userId,
        error: null
      };
    case LOGIN_FAIL:
      return {
        ...state,
        user: null,
        error: action.payload
      };
      case GET_USER_SUCCESS:
        return {
          ...state,
          userDetails: action.payload,
          error: null
        };
      case GET_USER_FAIL:
        return {
          ...state,
          userDetails: null,
          error: action.payload
        };
        case 'CREATE_PROPERTY_REQUEST':
          return {
              ...state,
              loading: true,
          };
      case 'CREATE_PROPERTY_SUCCESS':
          return {
              ...state,
              loading: false,
              property: action.payload,
              error: null,
          };
      case 'CREATE_PROPERTY_FAIL':
          return {
              ...state,
              loading: false,
              error: action.payload,
          };
      case GET_ALL_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload,
        error: null,
      };
    case GET_ALL_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
      case UPDATE_MAP_LOCATION:
        return {
          ...state,
          mapLocation: action.payload,
        };
        case UPLOAD_IMAGE_SUCCESS:
          return {
            ...state,
            imageUploadError: null,
            // Actualizar el estado según sea necesario para la carga de imágenes exitosa
          };
        case UPLOAD_IMAGE_FAIL:
          return {
            ...state,
            imageUploadError: action.payload,
            // Manejar la acción de carga de imágenes fallida
          };
          case GET_PROPERTIES_BY_SELLER_ID_SUCCESS:
      return {
        ...state,
        propertiesBySellerId: action.payload,
        error: null
      };
    case GET_PROPERTIES_BY_SELLER_ID_FAIL:
      return {
        ...state,
        propertiesBySellerId: [],
        error: action.payload
      };
      case GET_PROPERTIES_CLOSED_BY_SELLER_ID_SUCCESS:
      return {
        ...state,
        propertiesClosedBySellerId: action.payload,
        error: null
      };
    case GET_PROPERTIES_CLOSED_BY_SELLER_ID_FAIL:
      return {
        ...state,
        propertiesClosedBySellerId: [],
        error: action.payload
      };
      case EDIT_PROPERTY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case EDIT_PROPERTY_SUCCESS:
      return {
        ...state,
        properties: state.properties.map((property) =>
          property.id === action.payload.id ? action.payload : property
        ),
        loading: false,
        error: null,
      };
    case EDIT_PROPERTY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
      case GET_PROPERTY_BY_ID:
        return {
          ...state,
          property: action.payload,
        };
        case GET_PROPERTIES_PENDING_SUCCESS:
          return {
            ...state,
            pendingProperties: action.payload,
            loading: false,
          };
    
        case GET_PROPERTIES_PENDING_FAIL:
          return {
            ...state,
            error: action.payload,
            loading: false,
          };
          case GET_PROPERTIES_LIST_SUCCESS:
            return {
              ...state,
              activeProperties: action.payload,
              loading: false,
            };
      
          case GET_PROPERTIES_LIST_FAIL:
            return {
              ...state,
              error: action.payload,
              loading: false,
            };
            case CREATE_USER_REQUEST:
              return { ...state, loading: true };
        
            case CREATE_USER_SUCCESS:
              return { ...state, loading: false, seller: action.payload };
        
            case CREATE_USER_FAIL:
              return { ...state, loading: false, error: action.payload };
              case GET_ALL_SELLERS_SUCCESS:
                return {
                  ...state,
                  sellers: action.payload, // Guarda la lista de vendedores en el estado
                  error: null
                };
              case GET_ALL_SELLERS_FAIL:
                return {
                  ...state,
                  sellers: [], // Limpia la lista de vendedores en caso de fallo
                  error: action.payload
                };
                case UPDATE_SELLER_REQUEST:
                  return {
                    ...state,
                    loading: true,
                    error: null,
                  };
                  
                case UPDATE_SELLER_SUCCESS:
                  return {
                    ...state,
                    sellers: Array.isArray(state.sellers) 
                      ? state.sellers.map((seller) => 
                          seller.id === action.payload.id ? action.payload : seller
                        )
                      : [],  // Aseguramos que sellers sea siempre un array
                    loading: false,
                    error: null,
                  };
            
                case UPDATE_SELLER_FAIL:
                  return {
                    ...state,
                    loading: false,
                    error: action.payload,
                  };
                  case CREATE_VISITA_REQUEST:
                    case GET_ALL_VISITAS_REQUEST:
                    case GET_VISITAS_BY_PROPERTY_REQUEST:
                      return { ...state, loading: true };
                
                    case CREATE_VISITA_SUCCESS:
                      return {
                        ...state,
                        loading: false,
                        visitas: [...state.visitas, action.payload], // Añade la nueva visita
                      };
                
                    case GET_ALL_VISITAS_SUCCESS:
                      return {
                        ...state,
                        loading: false,
                        visitas: action.payload, // Carga todas las visitas
                      };
                
                    case GET_VISITAS_BY_PROPERTY_SUCCESS:
                      return {
                        ...state,
                        loading: false,
                        visitas: action.payload, // Carga visitas de una propiedad específica
                      };
                
                    case CREATE_VISITA_FAIL:
                    case GET_ALL_VISITAS_FAIL:
                    case GET_VISITAS_BY_PROPERTY_FAIL:
                      return {
                        ...state,
                        loading: false,
                        error: action.payload, // Manejo de errores
                      };
                      case GET_PROPERTIES_BY_SELLER:
                        return {
                          ...state,
                          sellerProperties: {
                            ...state.sellerProperties,
                            [action.payload.sellerId]: action.payload.properties, // Asigna las propiedades por sellerId
                          },
                        };
                      case GET_PROPERTIES_BY_SELLER_ERROR:
                        // Maneja otros errores si es necesario
                        return state; 
                        case FETCH_RENTALS_REQUEST:
                          return {
                            ...state,
                            loading: true,
                            error: null,
                          };
                        case FETCH_RENTALS_SUCCESS:
                          return {
                            ...state,
                            loading: false,
                            rentals: action.payload, // Supongamos que payload es un array de rentas
                            error: null,
                          };
                        case FETCH_RENTALS_FAILURE:
                          return {
                            ...state,
                            loading: false,
                            error: action.payload,
                          };
                    
                        case FETCH_RENTAL_REQUEST:
                          return {
                            ...state,
                            loading: true,
                            error: null,
                          };
                        case FETCH_RENTAL_SUCCESS:
                          return {
                            ...state,
                            loading: false,
                            rental: action.payload, // Supongamos que payload es un objeto de renta
                            error: null,
                          };
                        case FETCH_RENTAL_FAILURE:
                          return {
                            ...state,
                            loading: false,
                            error: action.payload,
                          };
                    
                        case CREATE_RENTAL_REQUEST:
                          return {
                            ...state,
                            loading: true,
                            error: null,
                          };
                        case CREATE_RENTAL_SUCCESS:
                          return {
                            ...state,
                            loading: false,
                            rentals: [...state.rentals, action.payload], // Agregar la nueva renta a la lista
                            error: null,
                          };
                        case CREATE_RENTAL_FAILURE:
                          return {
                            ...state,
                            loading: false,
                            error: action.payload,
                          };
                    
                        case UPDATE_RENTAL_REQUEST:
                          return {
                            ...state,
                            loading: true,
                            error: null,
                          };
                        case UPDATE_RENTAL_SUCCESS:
                          return {
                            ...state,
                            loading: false,
                            rentals: state.rentals.map((rental) =>
                              rental.id === action.payload.id ? action.payload : rental
                            ), // Actualizar la renta modificada
                            error: null,
                          };
                        case UPDATE_RENTAL_FAILURE:
                          return {
                            ...state,
                            loading: false,
                            error: action.payload,
                          };
                    
                        case DELETE_RENTAL_REQUEST:
                          return {
                            ...state,
                            loading: true,
                            error: null,
                          };
                        case DELETE_RENTAL_SUCCESS:
                          return {
                            ...state,
                            loading: false,
                            rentals: state.rentals.filter((rental) => rental.id !== action.payload), // Eliminar la renta
                            error: null,
                          };
                        case DELETE_RENTAL_FAILURE:
                          return {
                            ...state,
                            loading: false,
                            error: action.payload,
                          };

                        case CANCEL_RENTAL_REQUEST:
                        case REACTIVATE_RENTAL_REQUEST:
                          return {
                            ...state,
                            rentalsLoading: true,
                            rentalsError: null,
                          };
                        case CANCEL_RENTAL_SUCCESS:
                        case REACTIVATE_RENTAL_SUCCESS: {
                          const updatedRental = action.payload?.rental || null;
                          if (!updatedRental) {
                            return { ...state, rentalsLoading: false, rentalsError: null };
                          }
                          const mergeRentalInItem = (item) => {
                            if (!item) return item;
                            // Items de activeRentals tienen forma { ...property, rental: {...} }
                            if (item.rental && item.rental.id === updatedRental.id) {
                              return { ...item, rental: { ...item.rental, ...updatedRental } };
                            }
                            // Items planos
                            if (item.id === updatedRental.id) {
                              return { ...item, ...updatedRental };
                            }
                            return item;
                          };
                          const newActiveRentals = Array.isArray(state.activeRentals)
                            ? state.activeRentals.map(mergeRentalInItem)
                            : state.activeRentals;
                          const newRentals = Array.isArray(state.rentals)
                            ? state.rentals.map(mergeRentalInItem)
                            : state.rentals;
                          const newRentalDetail = state.rentalDetail
                            ? (state.rentalDetail.id === updatedRental.id
                                ? { ...state.rentalDetail, ...updatedRental }
                                : (state.rentalDetail.rental && state.rentalDetail.rental.id === updatedRental.id
                                    ? { ...state.rentalDetail, rental: { ...state.rentalDetail.rental, ...updatedRental } }
                                    : state.rentalDetail))
                            : state.rentalDetail;
                          return {
                            ...state,
                            rentalsLoading: false,
                            rentalsError: null,
                            activeRentals: newActiveRentals,
                            rentals: newRentals,
                            rentalDetail: newRentalDetail,
                          };
                        }
                        case CANCEL_RENTAL_FAILURE:
                        case REACTIVATE_RENTAL_FAILURE:
                          return {
                            ...state,
                            rentalsLoading: false,
                            rentalsError: action.payload,
                          };

                          case GET_CLOSED_PROPERTIES_SUCCESS:
                            return {
                              ...state,
                              closedProperties: action.payload,
                              error: null,
                            };
                          case GET_CLOSED_PROPERTIES_FAIL:
                            return {
                              ...state,
                              closedProperties: [],
                              error: action.payload,
                            };
              case SESSION_STARTED:
      return { ...state, sessionId: action.payload, error: null };
    case SESSION_ENDED:
      return { ...state, sessionId: null, error: null };
    case SESSION_HISTORY_SUCCESS:
      return {
        ...state,
        historyByUser: {
          ...state.historyByUser,
          [action.payload.userId]: action.payload.history,
        },
        error: null,
      };
    case SESSION_HISTORY_FAIL:
      return { ...state, error: action.payload };
    case SESSION_MONTHLY_SUCCESS:
      return {
        ...state,
        monthlyStatsByUser: {
          ...state.monthlyStatsByUser,
          [action.payload.userId]: action.payload.stats,
        },
        error: null,
      };
    case SESSION_MONTHLY_FAIL:
      return { ...state, error: action.payload };
    
    // Eventos del calendario
    case FETCH_EVENTS_REQUEST:
    case CREATE_EVENT_REQUEST:
    case UPDATE_EVENT_REQUEST:
    case DELETE_EVENT_REQUEST:
    case FETCH_EVENT_BY_ID_REQUEST:
    case CHANGE_EVENT_STATUS_REQUEST:
      return { ...state, eventsLoading: true, eventsError: null };

    case FETCH_EVENTS_SUCCESS:
      return { ...state, events: action.payload, eventsLoading: false };

    case FETCH_EVENT_BY_ID_SUCCESS:
      return { ...state, currentEvent: action.payload, eventsLoading: false };

    case CREATE_EVENT_SUCCESS:
      return { ...state, events: [...state.events, action.payload], eventsLoading: false };

    case UPDATE_EVENT_SUCCESS:
    case CHANGE_EVENT_STATUS_SUCCESS:
      return {
        ...state,
        events: state.events.map(ev => ev.id === action.payload.id ? action.payload : ev),
        currentEvent: state.currentEvent?.id === action.payload.id ? action.payload : state.currentEvent,
        eventsLoading: false
      };

    case DELETE_EVENT_SUCCESS:
      return {
        ...state,
        events: state.events.filter(ev => ev.id !== action.payload),
        eventsLoading: false
      };

    case FETCH_EVENTS_FAIL:
    case CREATE_EVENT_FAIL:
    case UPDATE_EVENT_FAIL:
    case DELETE_EVENT_FAIL:
    case FETCH_EVENT_BY_ID_FAIL:
    case CHANGE_EVENT_STATUS_FAIL:
      return { ...state, eventsLoading: false, eventsError: action.payload };

    // Eventos próximos (notificaciones)
    case FETCH_UPCOMING_EVENTS_REQUEST:
      return { ...state, upcomingEventsLoading: true };
    case FETCH_UPCOMING_EVENTS_SUCCESS:
      return { ...state, upcomingEvents: action.payload, upcomingEventsLoading: false };
    case FETCH_UPCOMING_EVENTS_FAIL:
      return { ...state, upcomingEventsLoading: false };

    // Marcar evento como visto
    case MARK_EVENT_SEEN_REQUEST:
      return state;
    case MARK_EVENT_SEEN_SUCCESS: {
      const { eventoId, sellerId } = action.payload;
      return {
        ...state,
        upcomingEvents: state.upcomingEvents.map(ev => {
          if (ev.id === eventoId && ev.agentes) {
            return {
              ...ev,
              agentes: ev.agentes.map(a =>
                a.id === sellerId ? { ...a, EventoAgente: { ...a.EventoAgente, visto: true } } : a
              )
            };
          }
          return ev;
        })
      };
    }
    case MARK_EVENT_SEEN_FAIL:
      return state;

    // ============= CLIENT CASES =============

    // Create Client
    case CREATE_CLIENT_REQUEST:
    case GET_CLIENTS_BY_SELLER_REQUEST:
    case GET_ALL_CLIENTS_REQUEST:
    case GET_CLIENT_BY_ID_REQUEST:
    case UPDATE_CLIENT_REQUEST:
    case DELETE_CLIENT_REQUEST:
    case ASSOCIATE_CLIENT_PROPERTY_REQUEST:
    case GET_CLIENTS_BY_PROPERTY_REQUEST:
      return { ...state, clientsLoading: true, clientsError: null };

    case CREATE_CLIENT_SUCCESS:
      return {
        ...state,
        clients: [...state.clients, action.payload.data],
        clientsBySeller: [...state.clientsBySeller, action.payload.data],
        clientsLoading: false,
        clientsError: null
      };

    case GET_CLIENTS_BY_SELLER_SUCCESS:
      return {
        ...state,
        clientsBySeller: action.payload.data,
        clientsLoading: false,
        clientsError: null
      };

    case GET_ALL_CLIENTS_SUCCESS:
      return {
        ...state,
        clients: action.payload.data,
        clientsLoading: false,
        clientsError: null
      };

    case GET_CLIENT_BY_ID_SUCCESS:
      return {
        ...state,
        currentClient: action.payload.data,
        clientsLoading: false,
        clientsError: null
      };

    case UPDATE_CLIENT_SUCCESS:
      return {
        ...state,
        clients: state.clients.map(client => 
          client.id === action.payload.data.id ? action.payload.data : client
        ),
        clientsBySeller: state.clientsBySeller.map(client => 
          client.id === action.payload.data.id ? action.payload.data : client
        ),
        currentClient: state.currentClient?.id === action.payload.data.id ? action.payload.data : state.currentClient,
        clientsLoading: false,
        clientsError: null
      };

    case DELETE_CLIENT_SUCCESS:
      return {
        ...state,
        clients: state.clients.map(client => 
          client.id === action.payload.clientId ? { ...client, activo: false } : client
        ),
        clientsBySeller: state.clientsBySeller.map(client => 
          client.id === action.payload.clientId ? { ...client, activo: false } : client
        ),
        clientsLoading: false,
        clientsError: null
      };

    case ASSOCIATE_CLIENT_PROPERTY_SUCCESS:
      return {
        ...state,
        clientsLoading: false,
        clientsError: null
      };

    case GET_CLIENTS_BY_PROPERTY_SUCCESS:
      return {
        ...state,
        clientsByProperty: action.payload.data,
        clientsLoading: false,
        clientsError: null
      };

    case CREATE_CLIENT_FAIL:
    case GET_CLIENTS_BY_SELLER_FAIL:
    case GET_ALL_CLIENTS_FAIL:
    case GET_CLIENT_BY_ID_FAIL:
    case UPDATE_CLIENT_FAIL:
    case DELETE_CLIENT_FAIL:
    case ASSOCIATE_CLIENT_PROPERTY_FAIL:
    case GET_CLIENTS_BY_PROPERTY_FAIL:
      return {
        ...state,
        clientsLoading: false,
        clientsError: action.payload
      };

    // ================ RENTAL MANAGEMENT CASES ================

    // Dashboard y vistas generales
    case FETCH_RENTAL_DASHBOARD_REQUEST:
    case FETCH_ACTIVE_RENTALS_REQUEST:
    case FETCH_RENTAL_DETAIL_REQUEST:
    case FETCH_OVERDUE_PAYMENTS_REQUEST:
    case FETCH_EXPIRING_CONTRACTS_REQUEST:
    case GENERATE_PAYMENT_SCHEDULE_REQUEST:
    case FETCH_RENTAL_PAYMENTS_REQUEST:
    case REGISTER_PAYMENT_REQUEST:
    case UPDATE_OVERDUE_PAYMENTS_REQUEST:
    case CREATE_RENTAL_ADJUSTMENT_REQUEST:
    case SIMULATE_RENTAL_ADJUSTMENT_REQUEST:
    case FETCH_ADJUSTMENT_HISTORY_REQUEST:
    case FETCH_UPCOMING_ADJUSTMENTS_REQUEST:
    case NOTIFY_ADJUSTMENT_REQUEST:
    case CREATE_RENTAL_TENANT_REQUEST:
    case FETCH_RENTAL_TENANTS_REQUEST:
    case UPDATE_RENTAL_TENANT_REQUEST:
    case DELETE_RENTAL_TENANT_REQUEST:
      return {
        ...state,
        rentalsLoading: true,
        rentalsError: null
      };

    case FETCH_RENTAL_DASHBOARD_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalDashboard: action.payload,
        rentalsError: null
      };

    case FETCH_ACTIVE_RENTALS_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        activeRentals: action.payload,
        rentalsError: null
      };

    case FETCH_RENTAL_DETAIL_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalDetail: action.payload,
        rentalsError: null
      };

    case FETCH_OVERDUE_PAYMENTS_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        overduePayments: action.payload,
        rentalsError: null
      };

    case FETCH_EXPIRING_CONTRACTS_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        expiringContracts: action.payload,
        rentalsError: null
      };

    case GENERATE_PAYMENT_SCHEDULE_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalsError: null
        // El schedule se genera automáticamente, se actualizará con fetchRentalPayments
      };

    case FETCH_RENTAL_PAYMENTS_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalPayments: action.payload,
        rentalsError: null
      };

    case REGISTER_PAYMENT_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalPayments: state.rentalPayments.map(payment => 
          payment.id === action.payload.id ? action.payload : payment
        ),
        rentalsError: null
      };

    case UPDATE_OVERDUE_PAYMENTS_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalsError: null
        // Los pagos se actualizarán automáticamente al refrescar la lista
      };

    case CREATE_RENTAL_ADJUSTMENT_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        adjustmentHistory: [action.payload, ...state.adjustmentHistory],
        rentalsError: null
      };

    case SIMULATE_RENTAL_ADJUSTMENT_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        adjustmentSimulation: action.payload,
        rentalsError: null
      };

    case FETCH_ADJUSTMENT_HISTORY_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        adjustmentHistory: action.payload,
        rentalsError: null
      };

    case FETCH_UPCOMING_ADJUSTMENTS_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        upcomingAdjustments: action.payload,
        rentalsError: null
      };

    case NOTIFY_ADJUSTMENT_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        adjustmentHistory: state.adjustmentHistory.map(adjustment => 
          adjustment.id === action.payload.id ? action.payload : adjustment
        ),
        rentalsError: null
      };

    case CREATE_RENTAL_TENANT_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalTenants: [...state.rentalTenants, action.payload],
        rentalsError: null
      };

    case FETCH_RENTAL_TENANTS_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalTenants: action.payload,
        rentalsError: null
      };

    case UPDATE_RENTAL_TENANT_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalTenants: state.rentalTenants.map(tenant => 
          tenant.id === action.payload.id ? action.payload : tenant
        ),
        rentalsError: null
      };

    case DELETE_RENTAL_TENANT_SUCCESS:
      return {
        ...state,
        rentalsLoading: false,
        rentalTenants: state.rentalTenants.filter(tenant => 
          tenant.id !== action.payload.tenantId
        ),
        rentalsError: null
      };

    case FETCH_RENTAL_DASHBOARD_FAIL:
    case FETCH_ACTIVE_RENTALS_FAIL:
    case FETCH_RENTAL_DETAIL_FAIL:
    case FETCH_OVERDUE_PAYMENTS_FAIL:
    case FETCH_EXPIRING_CONTRACTS_FAIL:
    case GENERATE_PAYMENT_SCHEDULE_FAIL:
    case FETCH_RENTAL_PAYMENTS_FAIL:
    case REGISTER_PAYMENT_FAIL:
    case UPDATE_OVERDUE_PAYMENTS_FAIL:
    case CREATE_RENTAL_ADJUSTMENT_FAIL:
    case SIMULATE_RENTAL_ADJUSTMENT_FAIL:
    case FETCH_ADJUSTMENT_HISTORY_FAIL:
    case FETCH_UPCOMING_ADJUSTMENTS_FAIL:
    case NOTIFY_ADJUSTMENT_FAIL:
    case CREATE_RENTAL_TENANT_FAIL:
    case FETCH_RENTAL_TENANTS_FAIL:
    case UPDATE_RENTAL_TENANT_FAIL:
    case DELETE_RENTAL_TENANT_FAIL:
      return {
        ...state,
        rentalsLoading: false,
        rentalsError: action.payload
      };

    case CLEAR_RENTAL_STATE:
      return {
        ...state,
        rentalDashboard: null,
        activeRentals: [],
        rentalDetail: null,
        overduePayments: [],
        expiringContracts: [],
        rentalPayments: [],
        adjustmentHistory: [],
        upcomingAdjustments: [],
        rentalTenants: [],
        adjustmentSimulation: null,
        rentalsLoading: false,
        rentalsError: null
      };

    case SET_RENTAL_LOADING:
      return {
        ...state,
        rentalsLoading: action.payload
      };

    // ================ ESTADÍSTICAS ================
    case FETCH_VISITAS_STATS_REQUEST:
    case FETCH_VISITAS_STATS_PERIOD_REQUEST:
    case FETCH_VISITAS_AGENT_STATS_REQUEST:
    case FETCH_SELLERS_STATS_REQUEST:
    case FETCH_REUNIONES_RANKING_REQUEST:
    case FETCH_REUNIONES_INFORME_REQUEST:
    case FETCH_REUNIONES_TIPS_REQUEST:
    case FETCH_REUNIONES_DASHBOARD_REQUEST:
    case FETCH_REUNIONES_COMPARATIVA_REQUEST:
    case FETCH_REUNIONES_ANUAL_REQUEST:
      return { ...state, estadisticasLoading: true, estadisticasError: null };

    case FETCH_VISITAS_STATS_SUCCESS:
      return { ...state, estadisticasLoading: false, visitasStats: action.payload };
    case FETCH_VISITAS_STATS_PERIOD_SUCCESS:
      return { ...state, estadisticasLoading: false, visitasStatsPeriod: action.payload };
    case FETCH_VISITAS_AGENT_STATS_SUCCESS:
      return { ...state, estadisticasLoading: false, visitasAgentStats: action.payload };
    case FETCH_SELLERS_STATS_SUCCESS:
      return { ...state, estadisticasLoading: false, sellersStats: action.payload };
    case FETCH_REUNIONES_RANKING_SUCCESS:
      return { ...state, estadisticasLoading: false, reunionesRanking: action.payload };
    case FETCH_REUNIONES_INFORME_SUCCESS:
      return { ...state, estadisticasLoading: false, reunionesInforme: action.payload };
    case FETCH_REUNIONES_TIPS_SUCCESS:
      return { ...state, estadisticasLoading: false, reunionesTips: action.payload };
    case FETCH_REUNIONES_DASHBOARD_SUCCESS:
      return { ...state, estadisticasLoading: false, reunionesDashboard: action.payload };
    case FETCH_REUNIONES_COMPARATIVA_SUCCESS:
      return { ...state, estadisticasLoading: false, reunionesComparativa: action.payload };
    case FETCH_REUNIONES_ANUAL_SUCCESS:
      return { ...state, estadisticasLoading: false, reunionesAnual: action.payload };

    case FETCH_VISITAS_STATS_FAIL:
    case FETCH_VISITAS_STATS_PERIOD_FAIL:
    case FETCH_VISITAS_AGENT_STATS_FAIL:
    case FETCH_SELLERS_STATS_FAIL:
    case FETCH_REUNIONES_RANKING_FAIL:
    case FETCH_REUNIONES_INFORME_FAIL:
    case FETCH_REUNIONES_TIPS_FAIL:
    case FETCH_REUNIONES_DASHBOARD_FAIL:
    case FETCH_REUNIONES_COMPARATIVA_FAIL:
    case FETCH_REUNIONES_ANUAL_FAIL:
      return { ...state, estadisticasLoading: false, estadisticasError: action.payload };

    case CLEAR_ESTADISTICAS_STATE:
      return {
        ...state,
        visitasStats: null,
        visitasStatsPeriod: null,
        visitasAgentStats: null,
        sellersStats: null,
        reunionesRanking: null,
        reunionesInforme: null,
        reunionesTips: null,
        reunionesList: null,
        activeSellers: null,
        estadisticasLoading: false,
        estadisticasError: null,
        reunionCrudLoading: false,
        reunionCrudError: null,
        reunionesDashboard: null,
        reunionesComparativa: null,
        reunionesAnual: null
      };

    // Reuniones CRUD
    case CREATE_REUNION_REQUEST:
    case UPDATE_REUNION_REQUEST:
    case DELETE_REUNION_REQUEST:
      return { ...state, reunionCrudLoading: true, reunionCrudError: null };

    case CREATE_REUNION_SUCCESS:
    case UPDATE_REUNION_SUCCESS:
      return { ...state, reunionCrudLoading: false };

    case DELETE_REUNION_SUCCESS:
      return { ...state, reunionCrudLoading: false };

    case CREATE_REUNION_FAIL:
    case UPDATE_REUNION_FAIL:
    case DELETE_REUNION_FAIL:
      return { ...state, reunionCrudLoading: false, reunionCrudError: action.payload };

    // Reuniones List
    case FETCH_REUNIONES_LIST_REQUEST:
      return { ...state, estadisticasLoading: true, estadisticasError: null };
    case FETCH_REUNIONES_LIST_SUCCESS:
      return { ...state, estadisticasLoading: false, reunionesList: action.payload };
    case FETCH_REUNIONES_LIST_FAIL:
      return { ...state, estadisticasLoading: false, estadisticasError: action.payload };

    // Active Sellers
    case FETCH_ACTIVE_SELLERS_REQUEST:
      return { ...state, estadisticasLoading: true };
    case FETCH_ACTIVE_SELLERS_SUCCESS:
      return { ...state, estadisticasLoading: false, activeSellers: action.payload };
    case FETCH_ACTIVE_SELLERS_FAIL:
      return { ...state, estadisticasLoading: false, estadisticasError: action.payload };

    // ================ VISITAS EXTERNAS ================
    case CREATE_VISITA_EXTERNA_REQUEST:
    case GET_VISITAS_EXTERNAS_REQUEST:
    case GET_VISITAS_EXTERNAS_BY_AGENT_REQUEST:
    case UPDATE_VISITA_EXTERNA_REQUEST:
    case DELETE_VISITA_EXTERNA_REQUEST:
      return { ...state, visitasExternasLoading: true, visitasExternasError: null };

    case CREATE_VISITA_EXTERNA_SUCCESS:
      return {
        ...state,
        visitasExternasLoading: false,
        visitasExternas: [...state.visitasExternas, action.payload],
        visitasExternasError: null
      };

    case GET_VISITAS_EXTERNAS_SUCCESS:
    case GET_VISITAS_EXTERNAS_BY_AGENT_SUCCESS:
      return {
        ...state,
        visitasExternasLoading: false,
        visitasExternas: action.payload,
        visitasExternasError: null
      };

    case UPDATE_VISITA_EXTERNA_SUCCESS:
      return {
        ...state,
        visitasExternasLoading: false,
        visitasExternas: state.visitasExternas.map(v =>
          v.id === action.payload.id ? action.payload : v
        ),
        visitasExternasError: null
      };

    case DELETE_VISITA_EXTERNA_SUCCESS:
      return {
        ...state,
        visitasExternasLoading: false,
        visitasExternas: state.visitasExternas.filter(v => v.id !== action.payload),
        visitasExternasError: null
      };

    case CREATE_VISITA_EXTERNA_FAIL:
    case GET_VISITAS_EXTERNAS_FAIL:
    case GET_VISITAS_EXTERNAS_BY_AGENT_FAIL:
    case UPDATE_VISITA_EXTERNA_FAIL:
    case DELETE_VISITA_EXTERNA_FAIL:
      return { ...state, visitasExternasLoading: false, visitasExternasError: action.payload };

    // Operaciones Externas (Punta Compradora)
    case CREATE_OPERACION_EXTERNA_REQUEST:
    case GET_OPERACIONES_EXTERNAS_REQUEST:
    case GET_OPERACION_EXTERNA_BY_ID_REQUEST:
    case UPDATE_OPERACION_EXTERNA_REQUEST:
    case DELETE_OPERACION_EXTERNA_REQUEST:
      return { ...state, operacionesExternasLoading: true, operacionesExternasError: null };

    case CREATE_OPERACION_EXTERNA_SUCCESS:
      return { ...state, operacionesExternasLoading: false, operacionesExternas: [...state.operacionesExternas, action.payload] };

    case GET_OPERACIONES_EXTERNAS_SUCCESS:
      return { ...state, operacionesExternasLoading: false, operacionesExternas: action.payload };

    case GET_OPERACION_EXTERNA_BY_ID_SUCCESS:
      return { ...state, operacionesExternasLoading: false, operacionExternaDetail: action.payload };

    case UPDATE_OPERACION_EXTERNA_SUCCESS:
      return {
        ...state,
        operacionesExternasLoading: false,
        operacionesExternas: state.operacionesExternas.map(op => op.id === action.payload.id ? action.payload : op),
        operacionExternaDetail: action.payload,
      };

    case DELETE_OPERACION_EXTERNA_SUCCESS:
      return {
        ...state,
        operacionesExternasLoading: false,
        operacionesExternas: state.operacionesExternas.filter(op => op.id !== action.payload),
      };

    case CREATE_OPERACION_EXTERNA_FAIL:
    case GET_OPERACIONES_EXTERNAS_FAIL:
    case GET_OPERACION_EXTERNA_BY_ID_FAIL:
    case UPDATE_OPERACION_EXTERNA_FAIL:
    case DELETE_OPERACION_EXTERNA_FAIL:
      return { ...state, operacionesExternasLoading: false, operacionesExternasError: action.payload };

    // ================ PROPERTY VERSIONING & APPROVAL ================
    case FETCH_PROPERTY_VERSIONS_REQUEST:
    case REVERT_PROPERTY_VERSION_REQUEST:
      return { ...state, versioningLoading: true, versioningError: null };

    case FETCH_PROPERTY_VERSIONS_SUCCESS:
      return { ...state, versioningLoading: false, propertyVersions: action.payload };

    case REVERT_PROPERTY_VERSION_SUCCESS:
      return { ...state, versioningLoading: false };

    case FETCH_PROPERTY_VERSIONS_FAIL:
    case REVERT_PROPERTY_VERSION_FAIL:
      return { ...state, versioningLoading: false, versioningError: action.payload };

    case FETCH_PROPERTY_COMMENTS_REQUEST:
    case ADD_PROPERTY_COMMENT_REQUEST:
      return { ...state, versioningLoading: true, versioningError: null };

    case FETCH_PROPERTY_COMMENTS_SUCCESS:
      return { ...state, versioningLoading: false, propertyComments: action.payload };

    case ADD_PROPERTY_COMMENT_SUCCESS:
      return { ...state, versioningLoading: false, propertyComments: [action.payload, ...state.propertyComments] };

    case MARK_COMMENT_READ_SUCCESS:
      return {
        ...state,
        propertyComments: state.propertyComments.map(c =>
          c.id === action.payload ? { ...c, leido: true } : c
        ),
      };

    case FETCH_PROPERTY_COMMENTS_FAIL:
    case ADD_PROPERTY_COMMENT_FAIL:
    case MARK_COMMENT_READ_FAIL:
      return { ...state, versioningLoading: false, versioningError: action.payload };

    case APPROVE_PROPERTY_REQUEST:
    case REJECT_PROPERTY_REQUEST:
    case REQUEST_REVISION_REQUEST:
      return { ...state, versioningLoading: true, versioningError: null };

    case APPROVE_PROPERTY_SUCCESS:
      return {
        ...state,
        versioningLoading: false,
        pendingProperties: state.pendingProperties.filter(p => p.id !== action.payload?.property?.id),
      };

    case REJECT_PROPERTY_SUCCESS:
    case REQUEST_REVISION_SUCCESS:
      return { ...state, versioningLoading: false };

    case APPROVE_PROPERTY_FAIL:
    case REJECT_PROPERTY_FAIL:
    case REQUEST_REVISION_FAIL:
      return { ...state, versioningLoading: false, versioningError: action.payload };

    // ================ VRC ================
    case CREATE_VRC_REQUEST:
    case FETCH_VRCS_REQUEST:
    case FETCH_VRC_BY_ID_REQUEST:
    case UPDATE_VRC_REQUEST:
    case DELETE_VRC_REQUEST:
    case FETCH_VRC_VERSIONS_REQUEST:
    case REVERT_VRC_VERSION_REQUEST:
    case FETCH_VRC_BY_CODE_REQUEST:
    case DUPLICATE_VRC_REQUEST:
    case FETCH_VRC_STATS_REQUEST:
      return { ...state, vrcLoading: true, vrcError: null };

    case CREATE_VRC_SUCCESS:
      return { ...state, vrcLoading: false, vrcs: [action.payload.data, ...state.vrcs] };

    case FETCH_VRCS_SUCCESS:
      return { ...state, vrcLoading: false, vrcs: action.payload.data, vrcsPagination: action.payload.pagination || null };

    case FETCH_VRC_BY_ID_SUCCESS:
      return { ...state, vrcLoading: false, vrcDetail: action.payload.data };

    case UPDATE_VRC_SUCCESS:
      return {
        ...state,
        vrcLoading: false,
        vrcDetail: action.payload.data,
        vrcs: state.vrcs.map(v => v.id === action.payload.data?.id ? action.payload.data : v),
      };

    case DELETE_VRC_SUCCESS:
      return {
        ...state,
        vrcLoading: false,
        vrcs: state.vrcs.filter(v => v.id !== action.payload),
        vrcDetail: state.vrcDetail?.id === action.payload ? null : state.vrcDetail,
      };

    case FETCH_VRC_VERSIONS_SUCCESS:
      return { ...state, vrcLoading: false, vrcVersions: action.payload.data };

    case REVERT_VRC_VERSION_SUCCESS:
      return { ...state, vrcLoading: false, vrcDetail: action.payload.data };

    case FETCH_VRC_BY_CODE_SUCCESS:
      return { ...state, vrcLoading: false, vrcDetail: action.payload.data };

    case DUPLICATE_VRC_SUCCESS:
      return { ...state, vrcLoading: false, vrcs: [action.payload.data, ...state.vrcs] };

    case FETCH_VRC_STATS_SUCCESS:
      return { ...state, vrcLoading: false, vrcStats: action.payload.data };

    case CREATE_VRC_FAIL:
    case FETCH_VRCS_FAIL:
    case FETCH_VRC_BY_ID_FAIL:
    case UPDATE_VRC_FAIL:
    case DELETE_VRC_FAIL:
    case FETCH_VRC_VERSIONS_FAIL:
    case REVERT_VRC_VERSION_FAIL:
    case FETCH_VRC_BY_CODE_FAIL:
    case DUPLICATE_VRC_FAIL:
    case FETCH_VRC_STATS_FAIL:
      return { ...state, vrcLoading: false, vrcError: action.payload };

    case CLEAR_VRC_DETAIL:
      return { ...state, vrcDetail: null, vrcVersions: null };

    // ================ ADMIN RENTALS (Solo Administración) ================
    case FETCH_ADMIN_RENTAL_DASHBOARD_REQUEST:
    case FETCH_ACTIVE_ADMIN_RENTALS_REQUEST:
    case FETCH_ADMIN_RENTAL_LIST_REQUEST:
    case FETCH_ADMIN_RENTAL_DETAIL_REQUEST:
    case FETCH_EXPIRING_ADMIN_RENTALS_REQUEST:
    case FETCH_OVERDUE_ADMIN_PAYMENTS_REQUEST:
    case FETCH_ADMIN_CONTRACT_SUMMARY_REQUEST:
    case CREATE_ADMIN_RENTAL_REQUEST:
    case UPDATE_ADMIN_RENTAL_REQUEST:
    case DELETE_ADMIN_RENTAL_REQUEST:
    case CANCEL_ADMIN_RENTAL_REQUEST:
    case REACTIVATE_ADMIN_RENTAL_REQUEST:
    case GENERATE_ADMIN_PAYMENT_SCHEDULE_REQUEST:
    case FETCH_ADMIN_RENTAL_PAYMENTS_REQUEST:
    case REGISTER_ADMIN_RENTAL_PAYMENT_REQUEST:
    case FETCH_UPCOMING_ADMIN_PAYMENTS_REQUEST:
    case UPDATE_OVERDUE_ADMIN_PAYMENTS_REQUEST:
    case CREATE_ADMIN_RENTAL_ADJUSTMENT_REQUEST:
    case SIMULATE_ADMIN_RENTAL_ADJUSTMENT_REQUEST:
    case FETCH_ADMIN_ADJUSTMENT_HISTORY_REQUEST:
    case FETCH_UPCOMING_ADMIN_ADJUSTMENTS_REQUEST:
    case NOTIFY_ADMIN_ADJUSTMENT_REQUEST:
    case CREATE_ADMIN_RENTAL_TENANT_REQUEST:
    case FETCH_ADMIN_RENTAL_TENANTS_REQUEST:
    case UPDATE_ADMIN_RENTAL_TENANT_REQUEST:
    case DELETE_ADMIN_RENTAL_TENANT_REQUEST:
      return { ...state, adminRentalsLoading: true, adminRentalsError: null };

    case FETCH_ADMIN_RENTAL_DASHBOARD_SUCCESS:
      return { ...state, adminRentalsLoading: false, adminRentalDashboard: action.payload };

    case FETCH_ACTIVE_ADMIN_RENTALS_SUCCESS:
      return { ...state, adminRentalsLoading: false, activeAdminRentals: action.payload };

    case FETCH_ADMIN_RENTAL_LIST_SUCCESS:
      return { ...state, adminRentalsLoading: false, adminRentalList: action.payload };

    case FETCH_ADMIN_RENTAL_DETAIL_SUCCESS:
      return { ...state, adminRentalsLoading: false, adminRentalDetail: action.payload };

    case FETCH_EXPIRING_ADMIN_RENTALS_SUCCESS:
      return { ...state, adminRentalsLoading: false, expiringAdminRentals: action.payload };

    case FETCH_OVERDUE_ADMIN_PAYMENTS_SUCCESS:
      return { ...state, adminRentalsLoading: false, overdueAdminPayments: action.payload };

    case FETCH_ADMIN_CONTRACT_SUMMARY_SUCCESS:
      return { ...state, adminRentalsLoading: false, adminContractSummary: action.payload };

    case CREATE_ADMIN_RENTAL_SUCCESS: {
      const newRental = action.payload?.adminRental || action.payload;
      return {
        ...state,
        adminRentalsLoading: false,
        adminRentalList: newRental ? [newRental, ...state.adminRentalList] : state.adminRentalList,
      };
    }

    case UPDATE_ADMIN_RENTAL_SUCCESS:
      return {
        ...state,
        adminRentalsLoading: false,
        adminRentalDetail: action.payload || state.adminRentalDetail,
        adminRentalList: state.adminRentalList.map((r) =>
          r.id === action.payload?.id ? action.payload : r
        ),
        activeAdminRentals: state.activeAdminRentals.map((r) =>
          r.id === action.payload?.id ? action.payload : r
        ),
      };

    case DELETE_ADMIN_RENTAL_SUCCESS:
      return {
        ...state,
        adminRentalsLoading: false,
        adminRentalList: state.adminRentalList.filter((r) => r.id !== action.payload?.id),
        activeAdminRentals: state.activeAdminRentals.filter((r) => r.id !== action.payload?.id),
        adminRentalDetail:
          state.adminRentalDetail?.id === action.payload?.id ? null : state.adminRentalDetail,
      };

    case CANCEL_ADMIN_RENTAL_SUCCESS:
    case REACTIVATE_ADMIN_RENTAL_SUCCESS:
      return {
        ...state,
        adminRentalsLoading: false,
        adminRentalDetail: action.payload || state.adminRentalDetail,
        adminRentalList: state.adminRentalList.map((r) =>
          r.id === action.payload?.id ? action.payload : r
        ),
        activeAdminRentals: state.activeAdminRentals.map((r) =>
          r.id === action.payload?.id ? action.payload : r
        ),
      };

    case GENERATE_ADMIN_PAYMENT_SCHEDULE_SUCCESS:
    case UPDATE_OVERDUE_ADMIN_PAYMENTS_SUCCESS:
      return { ...state, adminRentalsLoading: false };

    case FETCH_ADMIN_RENTAL_PAYMENTS_SUCCESS:
      return {
        ...state,
        adminRentalsLoading: false,
        adminRentalPayments: {
          data: action.payload?.data || [],
          contractInfo: action.payload?.contractInfo || null,
          autoGenerated: !!action.payload?.autoGenerated,
        },
      };

    case REGISTER_ADMIN_RENTAL_PAYMENT_SUCCESS:
      return {
        ...state,
        adminRentalsLoading: false,
        adminRentalPayments: {
          ...state.adminRentalPayments,
          data: state.adminRentalPayments.data.map((p) =>
            p.id === action.payload?.id ? action.payload : p
          ),
        },
      };

    case FETCH_UPCOMING_ADMIN_PAYMENTS_SUCCESS:
      return { ...state, adminRentalsLoading: false, upcomingAdminPayments: action.payload };

    case CREATE_ADMIN_RENTAL_ADJUSTMENT_SUCCESS:
      return {
        ...state,
        adminRentalsLoading: false,
        adminAdjustmentHistory: action.payload
          ? [action.payload, ...state.adminAdjustmentHistory]
          : state.adminAdjustmentHistory,
      };

    case SIMULATE_ADMIN_RENTAL_ADJUSTMENT_SUCCESS:
      return { ...state, adminRentalsLoading: false, adminAdjustmentSimulation: action.payload };

    case FETCH_ADMIN_ADJUSTMENT_HISTORY_SUCCESS:
      return { ...state, adminRentalsLoading: false, adminAdjustmentHistory: action.payload };

    case FETCH_UPCOMING_ADMIN_ADJUSTMENTS_SUCCESS:
      return { ...state, adminRentalsLoading: false, upcomingAdminAdjustments: action.payload };

    case NOTIFY_ADMIN_ADJUSTMENT_SUCCESS:
      return {
        ...state,
        adminRentalsLoading: false,
        adminAdjustmentHistory: state.adminAdjustmentHistory.map((adj) =>
          adj.id === action.payload?.id ? action.payload : adj
        ),
        upcomingAdminAdjustments: state.upcomingAdminAdjustments.map((adj) =>
          adj.id === action.payload?.id ? action.payload : adj
        ),
      };

    case CREATE_ADMIN_RENTAL_TENANT_SUCCESS:
      return {
        ...state,
        adminRentalsLoading: false,
        adminRentalTenants: action.payload
          ? [...state.adminRentalTenants, action.payload]
          : state.adminRentalTenants,
      };

    case FETCH_ADMIN_RENTAL_TENANTS_SUCCESS:
      return { ...state, adminRentalsLoading: false, adminRentalTenants: action.payload };

    case UPDATE_ADMIN_RENTAL_TENANT_SUCCESS:
      return {
        ...state,
        adminRentalsLoading: false,
        adminRentalTenants: state.adminRentalTenants.map((t) =>
          t.id === action.payload?.id ? action.payload : t
        ),
      };

    case DELETE_ADMIN_RENTAL_TENANT_SUCCESS:
      return {
        ...state,
        adminRentalsLoading: false,
        adminRentalTenants: state.adminRentalTenants.filter(
          (t) => t.id !== action.payload?.tenantId
        ),
      };

    case FETCH_ADMIN_RENTAL_DASHBOARD_FAIL:
    case FETCH_ACTIVE_ADMIN_RENTALS_FAIL:
    case FETCH_ADMIN_RENTAL_LIST_FAIL:
    case FETCH_ADMIN_RENTAL_DETAIL_FAIL:
    case FETCH_EXPIRING_ADMIN_RENTALS_FAIL:
    case FETCH_OVERDUE_ADMIN_PAYMENTS_FAIL:
    case FETCH_ADMIN_CONTRACT_SUMMARY_FAIL:
    case CREATE_ADMIN_RENTAL_FAIL:
    case UPDATE_ADMIN_RENTAL_FAIL:
    case DELETE_ADMIN_RENTAL_FAIL:
    case CANCEL_ADMIN_RENTAL_FAIL:
    case REACTIVATE_ADMIN_RENTAL_FAIL:
    case GENERATE_ADMIN_PAYMENT_SCHEDULE_FAIL:
    case FETCH_ADMIN_RENTAL_PAYMENTS_FAIL:
    case REGISTER_ADMIN_RENTAL_PAYMENT_FAIL:
    case FETCH_UPCOMING_ADMIN_PAYMENTS_FAIL:
    case UPDATE_OVERDUE_ADMIN_PAYMENTS_FAIL:
    case CREATE_ADMIN_RENTAL_ADJUSTMENT_FAIL:
    case SIMULATE_ADMIN_RENTAL_ADJUSTMENT_FAIL:
    case FETCH_ADMIN_ADJUSTMENT_HISTORY_FAIL:
    case FETCH_UPCOMING_ADMIN_ADJUSTMENTS_FAIL:
    case NOTIFY_ADMIN_ADJUSTMENT_FAIL:
    case CREATE_ADMIN_RENTAL_TENANT_FAIL:
    case FETCH_ADMIN_RENTAL_TENANTS_FAIL:
    case UPDATE_ADMIN_RENTAL_TENANT_FAIL:
    case DELETE_ADMIN_RENTAL_TENANT_FAIL:
      return { ...state, adminRentalsLoading: false, adminRentalsError: action.payload };

    case CLEAR_ADMIN_RENTAL_STATE:
      return {
        ...state,
        adminRentalDashboard: null,
        adminRentalList: [],
        activeAdminRentals: [],
        adminRentalDetail: null,
        adminRentalPayments: { data: [], contractInfo: null, autoGenerated: false },
        overdueAdminPayments: [],
        expiringAdminRentals: [],
        upcomingAdminPayments: [],
        adminAdjustmentHistory: [],
        upcomingAdminAdjustments: [],
        adminAdjustmentSimulation: null,
        adminRentalTenants: [],
        adminContractSummary: null,
        adminRentalsLoading: false,
        adminRentalsError: null,
      };

    default:
      return state;
  }
};


export default rootReducer;